import { render, staticRenderFns } from "./mailbox-list.vue?vue&type=template&id=241c248f&"
import script from "./mailbox-list.vue?vue&type=script&lang=js&"
export * from "./mailbox-list.vue?vue&type=script&lang=js&"
import style0 from "./mailbox-list.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports